var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chat',_vm._b({attrs:{"items":_vm.filteredMessages,"default-message":_vm.defaultMessage},on:{"message":_vm.sendMessage}},'chat',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }